import { viewerColors, type ViewerDatasetGroup } from "@modernary/mui/components/viewer";

// Example of sharing viewer config within an app.
export const group1: ViewerDatasetGroup = { colors: viewerColors[0] };
export const group2: ViewerDatasetGroup = { colors: viewerColors[1] };
export const group3: ViewerDatasetGroup = { colors: viewerColors[2] };
export const group4: ViewerDatasetGroup = { colors: viewerColors[3] };
export const group5: ViewerDatasetGroup = { colors: viewerColors[4] };
export const group6: ViewerDatasetGroup = { colors: viewerColors[5] };
export const group7: ViewerDatasetGroup = { colors: viewerColors[6] };

export const metadataContext = {
  1: { isIncluded: true, group: group1 },
  2: { isIncluded: true, group: group2 },
  3: { isIncluded: true, group: group3 },
  4: { isIncluded: true, group: group4 },
  5: { isIncluded: true, group: group5 },
  6: { isIncluded: true, group: group6 },
  7: { isIncluded: true, group: group7 },
};

export const additionalMetadata = [
  // Example -
  //   {
  //     id: 5,
  //     entity: "entityFive",
  //     sourceSystem: "sourceFive",
  //     subCategory: "subCatFive",
  //     label: "Air Pollution Sources",
  //     description: "example desc. 5",
  //   },
];
